import { gql } from "@apollo/client";

export const ERRORS_FRAGMENT = gql`
    fragment ErrorType on ErrorType {
        field
        messages
    }
`;
